import { P2Alert, P2Button } from "react-bootstrap-common-script";
import ApplicationCooLayout from "../../layout/application-coo-layout";
import { Separator } from "../../components/separator";
import { InfoCircle } from "../../assets/svg";
import { InfoCard } from "../../components/info";
import ReviewHouseholdStructureTable from "./review-endorse/review-household-structure-table";
import { useAppDispatch, useAppSelector } from "../../redux/hook";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useMemo, useState } from "react";
import { updateStageAStep5 } from "../../redux/slices/completed-steps-slice";
import { StructureStatusEnum } from "../../models/enum/structure-status.enum";
import { useInitialWindowScrollTo } from "../../hooks/use-initial-window-scroll-to";
import { PolymerAxios } from "../../utils/axios";
import { API_ApplicationDetail } from "../../utils/api";
import moment from "moment";
import GatherConsentTable from "../../components/table/gather-consent-table";
import { Helpers } from "../../utils/helper";
import { MyInfo } from "../../models/polymer/MyInfo.model";

function StageASuccess() {
  let navigate = useNavigate();
  const AppDispatch = useAppDispatch();
  const startApplicationFormData = useAppSelector(state => state.app.ApplicationStartSlice.formData);
  const applicationStep1FormData = useAppSelector(state => state.app.ApplicationStep1Slice.formData);
  const applicationStep5FormData = useAppSelector(state => state.app.ApplicationStep5Slice.formData);
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const loginUserStructureStatus = useAppSelector(state => state.auth.AuthenticationSlice.structureStatus);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  const application_id = useAppSelector(state => state.app.ApplicationIdSlice.applicationId);
  const [submittedDate, setSubmittedDate] = useState<string>("");
  
  const declarationInfo = useMemo(()=>{
    const info = applicationStep5FormData.holding_form_values.holding_owners?.find(item => item.myinfo.uinfin === loginUser?.uinfin)?.myinfo ?? applicationStep5FormData.holding_form_values.holding_occupiers?.find(item => item.myinfo.uinfin === loginUser?.uinfin)?.myinfo;
    return info ?? new MyInfo();
  },[applicationStep1FormData.household.owners, loginUser.uinfin, startApplicationFormData, applicationStep5FormData])

  useEffect(()=>{
    //Clear steps 1-5 routes
    AppDispatch(updateStageAStep5(true));
  },[AppDispatch])

  useInitialWindowScrollTo();

  const navigateToApplication = useCallback(()=>{
    navigate(`/application-coo?application_id=${application_id}`)
  },[application_id, navigate])


  useEffect(() => {
    PolymerAxios(loginUser?.uinfin ?? "", singpassToken).get(`${API_ApplicationDetail}?applicationUuid=${application_id}`).then((res) => {
      setSubmittedDate(res.data.last_updated_at);
    })
  }, [application_id, loginUser?.uinfin, singpassToken])

  const { date, time } = useMemo(() => {
    if(submittedDate.length > 0){
      return {date: moment(submittedDate).format('DD MMMM yyyy'), time: moment(submittedDate).format('hh:mma')}
    }else{
      return {date: moment().format('DD MMMM yyyy'), time: moment().format('hh:mma')}
    }
    
  }, [submittedDate])

  return(
    <ApplicationCooLayout>
      <div style={{display:"flex", justifyContent:"center"}}>
        <div className="polymer_stage-a_success_container">
          <P2Alert withCTA={true} variant="success" title={"Application has been created."} text={"Application has been successfully created. Please continue and inform the other owners to give their consent by logging in to the Change in Flat Ownership Dashboard."} link={`/transfer/application-coo?application_id=${application_id}`} linkText="Continue with application process"/>
          <Separator style={{marginTop:32}}/>
          <div className="polymer_stage-a_success_infoCard_container">
            <InfoCard style={{ backgroundColor: "#EFF8FA" }} icon={<InfoCircle />} description={"All current and proposed owners must be aware of and give consent to the change in flat ownership."} />
            <InfoCard style={{ backgroundColor: "#EFF8FA" }} icon={<InfoCircle />} description={"All owners are given 1 week to give their consent. If consent is not given by all owners within 2 week after creation of the application, your application will be cancelled."} />
          </div>

          <GatherConsentTable
              applicationSubmitted={`Application created on ${date}, at ${time}`}
              timeRemaining={`${7 - Helpers.formatGetDayLeft(date)} days left for everyone to give their consent.`}
            />

          <div className="polymer_stage-a_success_btn">
            <P2Button variant="primary-1" onClick={navigateToApplication}>Continue with application process</P2Button>
          </div>
          <Separator />
          <div className="polymer_stage-a_success_bottom_card">
            <div className="polymer_stage-a_success_bottom_card_location">
              <p className="polymer_stage-a_success_bottom_card_location_main_title">Details of submitted application</p>
              <p className="polymer_stage-a_success_bottom_card_location_title">Location</p>
              <p className="polymer_stage-a_success_bottom_card_location_content">Address:<br />{startApplicationFormData.selected_hdb_property?.address}</p>
            </div>
            <div className="polymer_stage-a_success_bottom_card_change_details">
              <ReviewHouseholdStructureTable isMainOutgoing={loginUserStructureStatus === StructureStatusEnum.outgoing}/>
            </div>
            <div className="polymer_stage-a_success_bottom_card_declaration">
              <p className="polymer_stage-a_success_bottom_card_location_title">Declaration and Authorisation</p>
              <div className="polymer_stage-a_success_bottom_card_declaration_content_container">
                <div className="polymer_stage-a_success_bottom_card_declaration_content_row">
                  <p>Name</p>
                  <p>{declarationInfo.name}</p>
                </div>
                {declarationInfo.email !== "" && declarationInfo.mobile_no !== "" && (
                  <>
                    <div className="polymer_stage-a_success_bottom_card_declaration_content_row">
                      <p>Email address</p>
                      <p className="polymer_stage-a_success_bottom_card_declaration_content_row_email">{declarationInfo.email}</p>
                    </div>
                    <div className="polymer_stage-a_success_bottom_card_declaration_content_row">
                      <p>Contact Number</p>
                      <p>{declarationInfo.mobile_no}</p>
                    </div>
                  </>
                )}
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </ApplicationCooLayout>
  );
}

export default StageASuccess;